var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "addBuyerDialog",
      attrs: {
        title: "新增采购员",
        visible: _vm.isShowAddBuyerDialog,
        width: "30%",
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.isShowAddBuyerDialog = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "body"
        },
        [
          _c(
            "div",
            { staticClass: "form-wrap" },
            [
              _c(
                "el-form",
                {
                  ref: "addForm",
                  attrs: {
                    rules: _vm.addFormRules,
                    model: _vm.addForm,
                    "label-width": "100px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "登录账号：", prop: "USER_NAME" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.addForm.USER_NAME,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "USER_NAME", $$v)
                          },
                          expression: "addForm.USER_NAME"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "用户名称：", prop: "NICK_NAME" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.addForm.NICK_NAME,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "NICK_NAME", $$v)
                          },
                          expression: "addForm.NICK_NAME"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "所属角色：", prop: "ROLE_ID" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "" },
                          model: {
                            value: _vm.addForm.ROLE_ID,
                            callback: function($$v) {
                              _vm.$set(_vm.addForm, "ROLE_ID", $$v)
                            },
                            expression: "addForm.ROLE_ID"
                          }
                        },
                        _vm._l(_vm.roleOptions, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号码：" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.addForm.MOBILE,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "MOBILE", $$v)
                          },
                          expression: "addForm.MOBILE"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "邮箱：", prop: "Email" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.addForm.Email,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "Email", $$v)
                          },
                          expression: "addForm.Email"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否可用：" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.addForm.ENABLED,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "ENABLED", $$v)
                          },
                          expression: "addForm.ENABLED"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("div", { staticClass: "el-dialog__footer" }, [
        _c(
          "div",
          {
            staticClass: "dialog-footer-cancle",
            on: { click: _vm.handleCancel }
          },
          [_vm._v("取 消")]
        ),
        _c(
          "div",
          {
            staticClass: "dialog-footer-submit",
            on: { click: _vm.handleDelSubmit }
          },
          [_vm._v("确 定")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }